import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Table, Card, Row, Col, Form, Modal as RBModal, Spinner, Tabs, Tab } from 'react-bootstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from 'reactstrap';
import { getK3Flows, setK3Flows } from '../../actions/k3flowAction';
import { BsClockHistory, BsEye } from 'react-icons/bs';
import IframeModal from '../../components/IframeModal';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

class FlowList extends Component {
  state = {
    searchKeyword: '',
    showCreator: false,
    newTitle: '',
    newDescription: '',
    newMid: '',
    newFriendlyVersion: '',
    creating: false,
    showVersionsModal: false,
    selectedFlowForVersions: null,
    versions: [],
    loadingVersions: false,
    showIframeModal: false,
    iframeUrl: '',
    iframeTitle: '',
    viewMode: localStorage.getItem('flowListViewMode') || 'grid',
    showConfigModal: false,
    showFieldsList: JSON.parse(localStorage.getItem('flowListShowFieldsList')) || {
      title: true,
      doc_mid: true,
      _id: true,
      version: true,
      createdAt: true,
      updatedAt: true
    },
    columnOrderList: JSON.parse(localStorage.getItem('flowListColumnOrderList')) || [
      'title', 'doc_mid', '_id', 'version', 'createdAt', 'updatedAt'
    ],
    showFieldsGrid: JSON.parse(localStorage.getItem('flowListShowFieldsGrid')) || {
      title: true,
      doc_mid: true,
      _id: true,
      version: true,
      createdAt: true,
      updatedAt: true
    },
    columnOrderGrid: JSON.parse(localStorage.getItem('flowListColumnOrderGrid')) || [
      'title', 'doc_mid', '_id', 'version', 'createdAt', 'updatedAt'
    ],
    showConfigTab: 'list',
    showEditModal: false,
    editingFlow: null
  };

  componentDidMount() {
    this.props.getK3Flows({ keyword: this.state.searchKeyword });
    document.title = this.state.searchKeyword ? `Flow List - ${this.state.searchKeyword}` : 'Flow List';
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.searchKeyword !== this.state.searchKeyword) {
      document.title = this.state.searchKeyword ? `Flow List - ${this.state.searchKeyword}` : 'Flow List';
    }
  }

  handleSearch = (e) => {
    e.preventDefault();
    this.props.getK3Flows({ keyword: this.state.searchKeyword });
  };

  handleView = (flow) => {
    let url = '';
    if (flow.doc_mid) {
      url = `/v1/flow/view?mid=${encodeURIComponent(flow.doc_mid)}`;
    } else if (flow._id) {
      url = `/v1/flow/view?id=${encodeURIComponent(flow._id)}`;
    }
    if (url) {
      window.open(url, '_blank');
    }
  };

  handleShowCreator = () => {
    this.setState({ showCreator: true, newTitle: '', newDescription: '', newMid: '', newFriendlyVersion: '' });
  };

  handleHideCreator = () => {
    this.setState({ 
      showCreator: false, 
      newTitle: '', 
      newDescription: '', 
      newMid: '', 
      newFriendlyVersion: '',
      creating: false 
    });
  };

  handleCreateFlow = async (e) => {
    e.preventDefault();
    const { newTitle, newDescription, newMid, newFriendlyVersion } = this.state;
    if (!newTitle.trim()) return;
    this.setState({ creating: true });
    const newFlow = {
      type: 'flow',
      title: newTitle,
      content: newDescription,
      metadata: { 
        nodes: [], 
        edges: [],
        friendly_version: newFriendlyVersion
      }
    };
    if (newMid && newMid.trim()) newFlow.doc_mid = newMid.trim();
    await this.props.setK3Flows([newFlow], { generate_version: true });
    await this.props.getK3Flows({ keyword: this.state.searchKeyword });
    this.handleHideCreator();
  };

  handleShowVersions = async (flow) => {
    this.setState({
      selectedFlowForVersions: flow,
      showVersionsModal: true,
      loadingVersions: true
    });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/k3doc/doc-mid-versions?doc_mid=${flow.doc_mid}`);
      if (response.status !== 200) {
        throw new Error('Failed to fetch versions');
      }
      const data = await response.json();
      const versions = data.data;
      this.setState({ versions, loadingVersions: false });
    } catch (error) {
      console.error('Error fetching versions:', error);
      this.setState({ loadingVersions: false });
    }
  };

  handleHideVersions = () => {
    this.setState({
      showVersionsModal: false,
      selectedFlowForVersions: null,
      versions: []
    });
  };

  handleViewVersion = (version) => {
    this.setState({
      showIframeModal: true,
      iframeUrl: `/v1/flow/view?id=${version._id}&&show_sidebar=false`,
      iframeTitle: version.title
    });
  };

  handleHideIframeModal = () => {
    this.setState({
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: ''
    });
  };

  handleQuickView = (flow) => {
    let url = '';
    if (flow.doc_mid) {
      url = `/v1/flow/view?mid=${encodeURIComponent(flow.doc_mid)}&quickview=1`;
    } else if (flow._id) {
      url = `/v1/flow/view?id=${encodeURIComponent(flow._id)}&quickview=1`;
    }
    if (url) {
      this.setState({
        showIframeModal: true,
        iframeUrl: url,
        iframeTitle: flow.title
      });
    }
  };

  setViewMode = (mode) => {
    this.setState({ viewMode: mode });
    localStorage.setItem('flowListViewMode', mode);
  };

  openConfigModal = () => this.setState({ showConfigModal: true });
  closeConfigModal = () => this.setState({ showConfigModal: false });

  handleChangeShowField = (tab, e) => {
    const { name, checked } = e.target;
    const key = tab === 'grid' ? 'showFieldsGrid' : 'showFieldsList';
    this.setState(prev => {
      const showFields = { ...prev[key], [name]: checked };
      localStorage.setItem(tab === 'grid' ? 'flowListShowFieldsGrid' : 'flowListShowFieldsList', JSON.stringify(showFields));
      return { [key]: showFields };
    });
  };

  setColumnOrder = (tab, order) => {
    const key = tab === 'grid' ? 'columnOrderGrid' : 'columnOrderList';
    this.setState({ [key]: order });
    localStorage.setItem(tab === 'grid' ? 'flowListColumnOrderGrid' : 'flowListColumnOrderList', JSON.stringify(order));
  };

  handleShowEditModal = (flow) => {
    this.setState({
      showEditModal: true,
      editingFlow: {
        _id: flow._id,
        doc_mid: flow.doc_mid,
        title: flow.title,
        friendlyVersion: flow.metadata?.friendly_version || '',
        description: flow.content || ''
      }
    });
  };

  handleEditFlowChange = (e) => {
    const { name, value } = e.target;
    this.setState(prev => ({
      editingFlow: {
        ...prev.editingFlow,
        [name]: value
      }
    }));
  };

  handleEditFlowSave = async () => {
    const { editingFlow } = this.state;
    if (!editingFlow) return;

    const updatedFlow = {
      _id: editingFlow._id,
      doc_mid: editingFlow.doc_mid,
      title: editingFlow.title,
      content: editingFlow.description,
      metadata: {
        ...this.props.flows.find(f => f._id === editingFlow._id)?.metadata,
        friendly_version: editingFlow.friendlyVersion
      }
    };

    try {
      await this.props.setK3Flows([updatedFlow], { generate_version: true });
      await this.props.getK3Flows({ keyword: this.state.searchKeyword });
      this.setState({ showEditModal: false, editingFlow: null });
    } catch (error) {
      console.error('Error updating flow:', error);
    }
  };

  handleHideEditModal = () => {
    this.setState({ showEditModal: false, editingFlow: null });
  };

  renderConfigModal = () => {
    const { showConfigModal, showFieldsList, columnOrderList, showFieldsGrid, columnOrderGrid, showConfigTab } = this.state;
    const allFields = [
      { key: 'title', label: 'Title' },
      { key: 'doc_mid', label: 'MID' },
      { key: '_id', label: 'ID' },
      { key: 'version', label: 'Version' },
      { key: 'createdAt', label: 'Created At' },
      { key: 'updatedAt', label: 'Updated At' }
    ];
    return (
      <RBModal show={showConfigModal} onHide={this.closeConfigModal} size="md">
        <RBModal.Header closeButton>
          <RBModal.Title>Config Show</RBModal.Title>
        </RBModal.Header>
        <RBModal.Body>
          <Tabs
            id="config-show-tabs"
            activeKey={showConfigTab}
            onSelect={k => this.setState({ showConfigTab: k })}
            className="mb-3"
          >
            <Tab eventKey="list" title="List View">
              <div className="mb-2 text-muted small">Kéo thả để đổi thứ tự cột.</div>
              <Form>
                <DragDropContext onDragEnd={result => {
                  if (!result.destination) return;
                  const newOrder = Array.from(columnOrderList);
                  const [removed] = newOrder.splice(result.source.index, 1);
                  newOrder.splice(result.destination.index, 0, removed);
                  this.setColumnOrder('list', newOrder);
                }}>
                  <Droppable droppableId="fields-droppable-list">
                    {(provided) => (
                      <div ref={provided.innerRef} {...provided.droppableProps}>
                        {columnOrderList.map((key, idx) => {
                          const f = allFields.find(f => f.key === key);
                          if (!f) return null;
                          return (
                            <Draggable key={f.key} draggableId={f.key} index={idx}>
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className={snapshot.isDragging ? 'bg-light p-1 rounded mb-1' : 'p-1 mb-1'}
                                >
                                  <Form.Check
                                    type="checkbox"
                                    label={f.label}
                                    name={f.key}
                                    checked={showFieldsList && f && f.key ? (showFieldsList[f.key] !== false) : true}
                                    onChange={e => this.handleChangeShowField('list', e)}
                                  />
                                </div>
                              )}
                            </Draggable>
                          );
                        })}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </Form>
            </Tab>
            <Tab eventKey="grid" title="Grid View">
              <div className="mb-2 text-muted small">Kéo thả để đổi thứ tự trường trên card.</div>
              <Form>
                <DragDropContext onDragEnd={result => {
                  if (!result.destination) return;
                  const newOrder = Array.from(columnOrderGrid);
                  const [removed] = newOrder.splice(result.source.index, 1);
                  newOrder.splice(result.destination.index, 0, removed);
                  this.setColumnOrder('grid', newOrder);
                }}>
                  <Droppable droppableId="fields-droppable-grid">
                    {(provided) => (
                      <div ref={provided.innerRef} {...provided.droppableProps}>
                        {columnOrderGrid.map((key, idx) => {
                          const f = allFields.find(f => f.key === key);
                          if (!f) return null;
                          return (
                            <Draggable key={f.key} draggableId={f.key} index={idx}>
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className={snapshot.isDragging ? 'bg-light p-1 rounded mb-1' : 'p-1 mb-1'}
                                >
                                  <Form.Check
                                    type="checkbox"
                                    label={f.label}
                                    name={f.key}
                                    checked={showFieldsGrid && f && f.key ? (showFieldsGrid[f.key] !== false) : true}
                                    onChange={e => this.handleChangeShowField('grid', e)}
                                  />
                                </div>
                              )}
                            </Draggable>
                          );
                        })}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </Form>
            </Tab>
          </Tabs>
        </RBModal.Body>
        <RBModal.Footer>
          <Button variant="secondary" onClick={this.closeConfigModal}>Close</Button>
        </RBModal.Footer>
      </RBModal>
    );
  };

  render() {
    const { flows, loading } = this.props;
    const { 
      searchKeyword, 
      showCreator, 
      newTitle, 
      newDescription, 
      newMid,
      newFriendlyVersion,
      creating,
      showVersionsModal,
      selectedFlowForVersions,
      versions,
      loadingVersions,
      showIframeModal,
      iframeUrl,
      iframeTitle,
      viewMode,
      showConfigModal,
      showFieldsList,
      columnOrderList,
      showFieldsGrid,
      columnOrderGrid,
      showConfigTab,
      showEditModal,
      editingFlow
    } = this.state;
    const showFields = viewMode === 'grid' ? showFieldsGrid : showFieldsList;
    const columnOrder = viewMode === 'grid' ? columnOrderGrid : columnOrderList;
    return (
      <div className="container-fluid p-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3>Danh sách Flow</h3>
          <div className="d-flex align-items-center gap-2">
            <Button
              variant={viewMode === 'grid' ? 'secondary' : 'outline-secondary'}
              className={viewMode === 'grid' ? 'me-1 border border-2 border-primary' : 'me-1'}
              onClick={() => this.setViewMode('grid')}
              title="Grid view"
              style={{ padding: '0.375rem 0.75rem', minWidth: '40px' }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-grid-3x3-gap-fill" viewBox="0 0 16 16">
                <path d="M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2zm5-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zM2 6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm6-1h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zm-9 5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2zm6-1h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z"/>
              </svg>
            </Button>
            <Button
              variant={viewMode === 'list' ? 'secondary' : 'outline-secondary'}
              className={viewMode === 'list' ? 'border border-2 border-primary' : ''}
              onClick={() => this.setViewMode('list')}
              title="List view"
              style={{ padding: '0.375rem 0.75rem', minWidth: '40px' }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M2.5 12.5A.5.5 0 0 1 3 12h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 8h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 4h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
              </svg>
            </Button>
            <Button variant="outline-info" onClick={this.openConfigModal}>Config Show</Button>
            <Button variant="primary" onClick={this.handleShowCreator}>Tạo mới Flow</Button>
          </div>
        </div>
        <form onSubmit={this.handleSearch} className="mb-3">
          <input
            type="text"
            placeholder="Tìm kiếm flow..."
            value={searchKeyword}
            onChange={e => this.setState({ searchKeyword: e.target.value })}
            className="form-control w-auto d-inline-block me-2"
          />
          <Button type="submit" variant="primary">Tìm kiếm</Button>
        </form>
        {loading ? <Spinner animation="border" /> : (
          viewMode === 'grid' ? (
            <Row>
              {flows.map(flow => (
                <Col key={flow._id} lg={3} md={4} sm={6} className="mb-4">
                  <Card className="h-100 shadow-sm">
                    <Card.Body>
                      <Card.Title className="text-truncate mb-2" title={flow.title}>
                        <h5>{flow.title}</h5>
                      </Card.Title>
                      <div className="small text-muted mb-2">
                        {columnOrder.map(key => showFields[key] !== false && (
                          <div key={key}>
                            {key === 'title' && flow.title}
                            {key === 'doc_mid' && (
                              <div>
                                <span className="fw-bold">MID:</span> {flow.doc_mid || '-'}
                              </div>
                            )}
                            {key === '_id' && (
                              <div>
                                <span className="fw-bold">ID:</span> {flow._id || '-'}
                              </div>
                            )}
                            {key === 'version' && (flow.metadata?.friendly_version || '-')}
                            {key === 'createdAt' && (
                              <div>
                                <span className="fw-bold">Created:</span> {flow.createdAt ? new Date(flow.createdAt).toLocaleString() : '-'}
                              </div>
                            )}
                            {key === 'updatedAt' && (
                              <div>
                                <span className="fw-bold">Updated:</span> {flow.updatedAt ? new Date(flow.updatedAt).toLocaleString() : '-'}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                      <div className="d-flex justify-content-center gap-3">
                        <Button size="sm" onClick={() => this.handleView(flow)} className="me-2">View</Button>
                        <Button 
                          size="sm" 
                          variant="outline-secondary"
                          onClick={() => this.handleShowVersions(flow)}
                          title="View Versions"
                        >
                          <BsClockHistory />
                        </Button>
                        <Button
                          size="sm"
                          variant="outline-info"
                          onClick={() => this.handleQuickView(flow)}
                          title="Quick View"
                        >
                          <BsEye />
                        </Button>
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={() => this.handleShowEditModal(flow)}
                          title="Edit Flow"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil" viewBox="0 0 16 16">
                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                          </svg>
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <Table striped bordered hover>
              <thead>
                <tr>
                  {columnOrder.map(key => showFields[key] !== false && (
                    <th key={key}>{({title:'Title',doc_mid:'MID',_id:'ID',version:'Version',createdAt:'Created At',updatedAt:'Updated At'})[key]||key}</th>
                  ))}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {flows.map(flow => (
                  <tr key={flow._id}>
                    {columnOrder.map(key => showFields[key] !== false && (
                      <td key={key}>
                        {key === 'title' && flow.title}
                        {key === 'doc_mid' && (flow.doc_mid || '-')}
                        {key === '_id' && (flow._id || '-')}
                        {key === 'version' && (flow.metadata?.friendly_version || '-')}
                        {key === 'createdAt' && (flow.createdAt ? new Date(flow.createdAt).toLocaleString() : '-')}
                        {key === 'updatedAt' && (flow.updatedAt ? new Date(flow.updatedAt).toLocaleString() : '-')}
                      </td>
                    ))}
                    <td>
                      <Button size="sm" onClick={() => this.handleView(flow)} className="me-2">View</Button>
                      <Button 
                        size="sm" 
                        variant="outline-secondary"
                        onClick={() => this.handleShowVersions(flow)}
                        title="View Versions"
                      >
                        <BsClockHistory />
                      </Button>
                      <Button
                        size="sm"
                        variant="outline-info"
                        onClick={() => this.handleQuickView(flow)}
                        title="Quick View"
                      >
                        <BsEye />
                      </Button>
                      <Button
                        size="sm"
                        variant="outline-primary"
                        onClick={() => this.handleShowEditModal(flow)}
                        title="Edit Flow"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil" viewBox="0 0 16 16">
                          <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                        </svg>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )
        )}
        <Modal isOpen={showCreator} toggle={this.handleHideCreator}>
          <Form onSubmit={this.handleCreateFlow}>
            <ModalHeader toggle={this.handleHideCreator}>Tạo mới Flow</ModalHeader>
            <ModalBody>
              <FormGroup className="mb-3">
                <Label>Tiêu đề Flow</Label>
                <Input
                  type="text"
                  value={newTitle}
                  onChange={e => this.setState({ newTitle: e.target.value })}
                  required
                  autoFocus
                />
              </FormGroup>
              <FormGroup className="mb-3">
                <Label>MID (không bắt buộc)</Label>
                <Input
                  type="text"
                  value={newMid}
                  onChange={e => this.setState({ newMid: e.target.value })}
                  placeholder="Nhập MID nếu muốn tự đặt"
                />
              </FormGroup>
              <FormGroup className="mb-3">
                <Label>Friendly Version (không bắt buộc)</Label>
                <Input
                  type="text"
                  value={newFriendlyVersion}
                  onChange={e => this.setState({ newFriendlyVersion: e.target.value })}
                  placeholder="Ví dụ: v1.0.0"
                />
              </FormGroup>
              <FormGroup className="mb-3">
                <Label>Mô tả</Label>
                <Input
                  type="textarea"
                  rows={3}
                  value={newDescription}
                  onChange={e => this.setState({ newDescription: e.target.value })}
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.handleHideCreator} disabled={creating}>Đóng</Button>
              <Button color="primary" type="submit" disabled={!newTitle.trim() || creating}>
                {creating ? 'Đang tạo...' : 'Tạo mới'}
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <IframeModal
          show={showIframeModal}
          onHide={this.handleHideIframeModal}
          url={iframeUrl}
          title={iframeTitle}
          dialogClassName="iframe-modal-zindex"
        />
        
        <Modal isOpen={showVersionsModal} toggle={this.handleHideVersions} size="xl">
          <ModalHeader toggle={this.handleHideVersions}>
            Version History - {selectedFlowForVersions?.title}
          </ModalHeader>
          <ModalBody>
            {loadingVersions ? (
              <div className="text-center p-5">
                <Spinner animation="border" />
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Version</th>
                      <th>Friendly Version</th>
                      <th>Version Note</th>
                      <th>Title</th>
                      <th>Created At</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {versions.map((version, index) => (
                      <tr key={index}>
                        <td>{version._id}</td>
                        <td>{version.version}</td>
                        <td>{version.friendly_version}</td>
                        <td>{version.version_note}</td>
                        <td>{version.title}</td>
                        <td>{new Date(version.createdAt).toLocaleString()}</td>
                        <td>
                          <Button
                            color="outline-primary"
                            size="sm"
                            onClick={() => this.handleViewVersion(version)}
                          >
                            View
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.handleHideVersions}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
        {this.renderConfigModal()}

        <Modal isOpen={this.state.showEditModal} toggle={this.handleHideEditModal}>
          <ModalHeader toggle={this.handleHideEditModal}>Chỉnh sửa thông tin Flow</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup className="mb-3">
                <Label>Tiêu đề</Label>
                <Input
                  type="text"
                  name="title"
                  value={this.state.editingFlow?.title || ''}
                  onChange={this.handleEditFlowChange}
                />
              </FormGroup>
              <FormGroup className="mb-3">
                <Label>Friendly Version</Label>
                <Input
                  type="text"
                  name="friendlyVersion"
                  value={this.state.editingFlow?.friendlyVersion || ''}
                  onChange={this.handleEditFlowChange}
                  placeholder="Ví dụ: v1.0.0"
                />
              </FormGroup>
              <FormGroup className="mb-3">
                <Label>Mô tả</Label>
                <Input
                  type="textarea"
                  name="description"
                  value={this.state.editingFlow?.description || ''}
                  onChange={this.handleEditFlowChange}
                  rows={3}
                />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.handleHideEditModal}>Hủy</Button>
            <Button color="primary" onClick={this.handleEditFlowSave}>Lưu thay đổi</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  flows: state.k3flowReducer.flows || [],
  loading: state.k3flowReducer.loading,
});

export default connect(mapStateToProps, { getK3Flows, setK3Flows })(FlowList); 